import '../PublicPage.css';

export default function IndonesiaItineraryPage() {
    return (
        <div className="public-page indonesia-page">
            <header className="public-hero">
                <div className="public-hero-content">
                    <h1>Indonesia Itinerary</h1>
                    <p>Tropical archipelagos, spiritual retreats, and wild adventures.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>Why visit Indonesia?</h3>
                            <p>With over 17,000 islands, Indonesia offers endless variety. From the spiritual heart of Bali to the volcanic landscapes of Java and the dragons of Komodo.</p>
                        </div>
                        <div className="modern-card">
                            <h3>Featured: 2-Week Island Hopper</h3>
                            <p>Bali, Nusa Penida, and Gili Islands. A perfect mix of relaxation, culture, and nature.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>Top Destinations</h2>
                    <ul className="benefits-list">
                        <li><strong>Bali</strong>: The Island of the Gods.</li>
                        <li><strong>Ubud</strong>: Cultural heart and lush rice terraces.</li>
                        <li><strong>Komodo</strong>: Home to the world's largest lizards.</li>
                        <li><strong>Yogyakarta</strong>: Ancient temples and royal heritage.</li>
                    </ul>
                </div>
            </section>

            <section className="public-section white-bg" style={{ textAlign: 'center' }}>
                <div className="section-inner">
                    <h2>Ready to plan your Indonesia trip?</h2>
                    <p style={{ marginBottom: '32px' }}>Let Raisa AI create a personalized itinerary for you in seconds.</p>
                    <button className="submit-btn-primary" style={{ maxWidth: '300px' }} onClick={() => window.location.href = '/?prompt=Plan a 14-day adventure in Indonesia visiting Bali, Ubud and Komodo'}>
                        Plan my Indonesia Trip
                    </button>
                </div>
            </section>
        </div>
    );
}
